import { render, staticRenderFns } from "./moduleTitle.vue?vue&type=template&id=54928f28&"
import script from "./moduleTitle.vue?vue&type=script&lang=js&"
export * from "./moduleTitle.vue?vue&type=script&lang=js&"
import style0 from "./moduleTitle.vue?vue&type=style&index=0&id=54928f28&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports